import { deleteLocalStorage, setLocalStorage } from "@/api/localStorage";
import { service } from "@/api/service ";
import { toastError } from "@/components/custom/Toast";
import router from "@/router";

const state = {
  isAuth: false,
  email: "",
  code: "",
  is_blocked: false,
};
const getters = {
  checkAuth(state) {
    return state.isAuth;
  },
  checkIsBlocked(state) {
    return state.is_blocked;
  },
  emailGet: (state) => {
    return state.email;
  },
  codeGet: (state) => {
    return state.code;
  },
};

const actions = {
  loggingOut({ commit }) {
    console.log("loggin out");
    service.getFun(`logout`).then(
      (result) => {
        if (result) {
          deleteLocalStorage("token");
          commit("loggingOut");
          router.push("/").catch(() => {});
        }
      },
      (error) => {
        toastError(error);
      }
    );
  },
  // loggingIn({ commit }, payload) {
  //   service
  //     .postAuthFun(service.deleteNullValues(payload), "login", null, {
  //       actions: [],
  //     })
  //     .then(
  //       (result) => {
  //         if (result) {
  //           console.log(result, "login res");
  //           setLocalStorage("token", result.data.token);
  //           setLocalStorage("user", JSON.stringify(result?.data.user));
  //           updateAuthHeaders();
  //           commit("isBlocked", result.data.user.is_blocked);
  //           // commit("loggingIn");
  //           router.push("/home");
  //         }
  //       },
  //       (error) => {
  //         toastError(error);
  //       }
  //     );
  // },
  register({ commit }, payload) {
    service
      .postAuthFun(service.deleteNullValues(payload), "register", null, {
        actions: [],
      })
      .then(
        (result) => {
          if (result) {
            setLocalStorage("token", result.data.data.token);
            commit("loggingIn");
            router.push("/login");
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  resetPassword({ commit }, payload) {
    service
      .postAuthFun(service.deleteNullValues(payload), "password/email", null, {
        actions: [],
      })
      .then(
        (result) => {
          if (result) {
            commit("emailSet", payload.email);
            router.push("/CodeCheck");
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  checkCode({ commit }, payload) {
    service
      .postAuthFun(
        service.deleteNullValues(payload),
        "password/code/check",
        null,
        {
          actions: [],
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("codeSet", payload.code);
            router.push("/ResetPassword");
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  changePassword({ commit }, payload) {
    service
      .postAuthFun(service.deleteNullValues(payload), "password/reset", null, {
        actions: [],
      })
      .then(
        (result) => {
          if (result) {
            deleteLocalStorage("token");
            commit("loggingIn");
            router.push("/login");
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
};

const mutations = {
  loggingOut(state) {
    state.isAuth = !state.isAuth;
  },
  loggingIn(state, payload) {
    console.log(payload, "mutation");
    state.isAuth = !state.isAuth;
    state.email = payload.email;
    state.password = payload.password;
  },
  isBlocked(state, payload) {
    console.log(payload);
    state.is_blocked = payload.result;
  },
  emailSet(state, payload) {
    state.email = payload;
  },
  codeSet(state, payload) {
    state.code = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
